import { useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { trackPromise } from 'react-promise-tracker';
import { useRecaptchaContext } from '../contexts/RecaptchaContext';
import { Theme } from '../data/DesignTypes';
import { getLockerPluginOptions } from '../services/queryParams';
import { RECAPTCHA_COUNTER, RECAPTCHA_SITE_KEY, RECAPTCHA_TRIGGER_LIMIT } from '../Settings';
import { Api } from '../utils/Api';
import { has3rdPartyCookiesEnabled } from '../utils/ThirdPartyCookies';

function RecaptchaComponent() {
    const {recaptchaValidated, setRecaptchaValidated} = useRecaptchaContext();
    let lockerPluginOptions = getLockerPluginOptions();
       
    useEffect(() => {
        setRecaptchaCurrentCounter();
    }, [])

    const onChangeRecaptcha =(value: string | null) => {
        trackPromise(Api.Get().ValidateRecaptchaToken(value).then(response=>{
            setRecaptchaValidated(response);
            if(response && has3rdPartyCookiesEnabled()){
                sessionStorage.setItem(RECAPTCHA_COUNTER!, "0");
            }
        }));
    }
    
    const getRecaptchaCurrentCounter = (): number =>{
        if(!has3rdPartyCookiesEnabled()){
            return RECAPTCHA_TRIGGER_LIMIT;
        }

        return (sessionStorage.getItem(RECAPTCHA_COUNTER!) || 0) as unknown as number;
    }

    const setRecaptchaCurrentCounter = (): void =>{
        if(!has3rdPartyCookiesEnabled()){
            return;
        }

        let recaptchaCounter = getRecaptchaCurrentCounter();
        sessionStorage.setItem(RECAPTCHA_COUNTER!, (++recaptchaCounter).toString());
        if(recaptchaCounter <= RECAPTCHA_TRIGGER_LIMIT){
            setRecaptchaValidated(true);
        }
    }

    return (!recaptchaValidated ?
                <div className='lockers-plugin-recaptcha-container'>            
                    <ReCAPTCHA
                    sitekey= {RECAPTCHA_SITE_KEY}
                    onChange = {onChangeRecaptcha}
                    theme = {lockerPluginOptions.theme == Theme.dark ? 'dark': 'light'}
                    hl = {lockerPluginOptions.langCode}
                    badge = 'inline'/>
                </div> : <></>
    );
}

export default RecaptchaComponent;